export default function(url){
    if(!url) return;
    const save_link:HTMLAnchorElement = document.createElement( "a");
    save_link.setAttribute('download', '')
    save_link.href = url
    const ev = document.createEvent("MouseEvents");
    ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    save_link.dispatchEvent(ev);
}
